import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';

@Component({
  selector: 'app-traitement-data-debit-min-max',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-debit-min-max.component.html',
  styleUrl: './traitement-data-debit-min-max.component.scss'
})
export class TraitementDataDebitMinMaxComponent {
  @Input() patient: Patient | undefined;
}
